import { UTOPIA_CONTACT_EMAIL } from '../../utopia/constants'

export type LegalSection = {
  title: string
  paragraphs?: string[]
  bullets?: string[]
}

const contactLine = UTOPIA_CONTACT_EMAIL
  ? `Contact : ${UTOPIA_CONTACT_EMAIL}`
  : 'Contact : .csystem'

export const UTOPIA_LEGAL_SECTIONS: LegalSection[] = [
  {
    title: '1. Éditeur du site',
    paragraphs: ['Le présent site est édité par :'],
    bullets: [
      'Nom du serveur : Utopie',
      'Responsable : CSystem',
      contactLine,
    ],
  },
  {
    title: '2. Hébergement',
    paragraphs: ['Le site est hébergé par :'],
    bullets: [
      'Hébergeur : Contabo',
      'Site web : https://contabo.com/en/',
    ],
  },
  {
    title: '3. Activité',
    paragraphs: [
      'Ce site est un site communautaire lié à un serveur de jeu Minecraft.',
      'Il ne propose aucun service payant, aucune vente, et ne collecte pas de données sensibles à des fins commerciales.',
    ],
  },
  {
    title: '4. Propriété intellectuelle',
    paragraphs: [
      'Le contenu du site (textes, images, logos) appartient au serveur Utopie sauf mention contraire.',
      'Minecraft est une marque déposée appartenant à Mojang Studios. Ce site n\'est pas affilié à Mojang ou Microsoft.',
    ],
  },
  {
    title: '5. Données personnelles',
    paragraphs: [
      'Aucune donnée personnelle n\'est vendue ou utilisée à des fins commerciales.',
      'Les données éventuellement collectées (ex : formulaire de contact ou Discord) sont uniquement utilisées pour la gestion du serveur.',
      'Conformément à la réglementation en vigueur, vous pouvez demander la suppression de vos données.',
    ],
  },
  {
    title: '6. Responsabilité',
    paragraphs: ['Le responsable du site ne peut être tenu responsable :'],
    bullets: [
      'des interruptions du serveur',
      'des pertes de données en jeu',
      'des comportements des utilisateurs',
    ],
  },
]
